import { Link, Tabs, Text } from 'platform-components';
import React, { useMemo } from 'react';

import './subject-page__grade-tabs.scss';

interface Props {
    shouldShowGradeTabs: boolean;
    subjectPages: Array<any>;
    subject: string;
    currentGrade: number | null;
    onClickTab: (grade: number) => void;
}

const GradeTabs = (props: Props) => {
    const { shouldShowGradeTabs, subjectPages, subject, currentGrade, onClickTab } = props;

    const memoizedSubjects = useMemo((): Array<React.ReactElement> => {
        const subjects = subjectPages.map(
            ({ grade: subjectPageGrade }): React.ReactElement => (
                <Link isRouter pseudo theme={Link.THEME.INHERIT}>
                    <Tabs.Tab
                        id={`library.subjectTab.${subject}.${subjectPageGrade}`}
                        key={`library.subjectTab.${subject}.${subjectPageGrade}`}
                        mix="subject-page__tab"
                        onTabSelect={() => onClickTab(subjectPageGrade)}
                        selected={subjectPageGrade === currentGrade}
                    >
                        <Text id="library.subjectPage.gradeTab" values={{ grade: subjectPageGrade }} />
                    </Tabs.Tab>
                </Link>
            )
        );

        subjects.unshift(
            <Tabs.Tab id="library.subjectTabs.label" mix="subject-page__tabs-label">
                <Text id="library.subjectPage.gradeLabel" weight={Text.WEIGHT.M} />
            </Tabs.Tab>
        );

        return subjects;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subjectPages, currentGrade, onClickTab]);

    if (!shouldShowGradeTabs) {
        return null;
    }

    return (
        <Tabs mix="subject-page__tabs" withDivider={true}>
            {memoizedSubjects}
        </Tabs>
    );
};

export default GradeTabs;
